function brandsPagination() {
    const paginationContainer = document.querySelector('.js-brands-container .brands-pagination-container');
    const paginateSize = parseInt(paginationContainer.dataset.brandsPerPage);
    const allLinks = document.querySelectorAll('.js-brands-container #myList .navList-item');

    if(!allLinks.length > paginateSize) return;
    const partsWrapper = paginationContainer.querySelector('.brands-paginate-parts');
    const totalParts = Math.ceil(allLinks.length / paginateSize);
    const prevBtn = paginationContainer.querySelector('[data-btn-action="prev"]');
    const nextBtn = paginationContainer.querySelector('[data-btn-action="next"]');

    // add parts and select first by default
    if(!partsWrapper.hasChildNodes()) {
        for(let i=0;i<totalParts;i++) {
            const part = document.createElement('li');
            part.textContent = i + 1;
            part.setAttribute('data-part', i+1);
            if(i===0) part.classList.add('active-part');
            // hides other parts greater than 2 except last
            if(totalParts >= 4 && (i+1) > 2 && (i+1 !== totalParts)) part.classList.add('hidden');
            partsWrapper.appendChild(part);
        }
    }

    // function to add pagination dots
    function paginationDots() {
        const allParts = partsWrapper.querySelectorAll('li');
        const thirdLastPart = allParts.length - 3;
        const secondLastPart = allParts.length - 2;
        const lastPart = allParts.length - 1;
        const crrActivePart = partsWrapper.querySelector('.active-part');
        const dotspart = partsWrapper.querySelector('.active-part')?.nextElementSibling;

        // manage dots if current active part is last
        if(allParts[lastPart].classList.contains('active-part') && totalParts > 3) {
            allParts[secondLastPart].classList.add('has-dots-left');
            allParts[0].classList.add('margin-right')
        }

        if(crrActivePart === allParts[thirdLastPart] || crrActivePart === allParts[secondLastPart] || crrActivePart === allParts[lastPart]) {
            crrActivePart.classList.remove('has-dots');
            allParts[lastPart].classList.remove('margin-left');
            if(crrActivePart !== allParts[lastPart]) {
                crrActivePart.classList.remove('has-dots-left');
                allParts[0].classList.remove('margin-right');  
            }
            return;
        };

        allParts[secondLastPart].classList.remove('has-dots-left');
        allParts[0].classList.remove('margin-right');
        crrActivePart.classList.remove('has-dots');
        dotspart?.classList.add('has-dots');
        allParts[lastPart].classList.add('margin-left');
    }
    paginationDots();

    paginationContainer.classList.remove('hidden');


    // Function to divide into groups of paginateSize
    function divideIntoGroups(elements, groupSize) {
        let groups = [];
        let remainingElements = [...elements];

        // While there are enough elements for a full group
        while (remainingElements.length >= groupSize) {
            let group = remainingElements.splice(0, groupSize); // Take groupSize elements
            groups.push(group);
        }

        // If any remaining elements are left (less than groupSize), make the last group
        if (remainingElements.length > 0) {
            groups.push(remainingElements); // Add remaining elements as the last group
        }

        return groups;
    }
    // Divide the 'li' elements into groups of paginateSize
    let groupedElements = divideIntoGroups(allLinks, paginateSize);


    // handle parts click event
    partsWrapper.querySelectorAll('li').forEach(part => {
        part.addEventListener('click', (e) => {
            partsWrapper.querySelector('.active-part').classList.remove('active-part');
            part.classList.add('active-part');

            toggleParts(parseInt(part.dataset.part) - 1);

            // enable/disable pagination btn
            parseInt(part.dataset.part) === 1 ? prevBtn.classList.add('disabled') : prevBtn.classList.remove('disabled');
            parseInt(part.dataset.part) === totalParts ? nextBtn.classList.add('disabled') : nextBtn.classList.remove('disabled');

            // smooth scroll to top of the brands list
            if(e.pointerType === 'touch') {
                document.getElementById('azBrandsTable-mobile').scrollIntoView({
                    behavior: 'smooth', // Optional: smooth scrolling effect
                    block: 'start'      // Scrolls to the start of the element
                });
            }


            // handle parts visibility
            if(totalParts > 3) {
                const allParts = partsWrapper.querySelectorAll('li');
                const activePart = partsWrapper.querySelector('.active-part');
                const previousPart = activePart.previousElementSibling;
                const nextPart = activePart.nextElementSibling;
                const lastPart = partsWrapper.querySelector('li:last-of-type');

                allParts.forEach(part => part.classList.add('hidden'));
                activePart.classList.remove('hidden');
                nextPart?.classList.remove('hidden');
                lastPart?.classList.remove('hidden');

                // if last part is active
                if(lastPart.classList.contains('active-part')) {
                    previousPart.classList.remove('hidden');
                    allParts[0].classList.remove('hidden');
                }

                // update pagination dots
                paginationDots();
            }
        })
    })


    // handle btns click event
    paginationContainer.querySelectorAll('.paginate-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            const currentPart = parseInt(partsWrapper.querySelector('.active-part').dataset.part);
            if(btn.dataset.btnAction === 'prev') {
                partsWrapper.querySelector(`[data-part="${currentPart - 1}"]`)?.dispatchEvent(new Event('click'));
            } else {
                partsWrapper.querySelector(`[data-part="${currentPart + 1}"]`)?.dispatchEvent(new Event('click'));
            }
        })
    })


    // toggle part list items
    function toggleParts(part) {
        const activelist = groupedElements[part];
        allLinks.forEach(item => {
            item.dataset.toggle = 'off'
        })
        activelist?.forEach(item => item.dataset.toggle = 'on');
    }

    // initial check and hide/show brands
    function hideShowBrands() {
        const firstPart = partsWrapper.querySelector('li');
        firstPart?.dispatchEvent(new Event('click'));
    }
    hideShowBrands();
}

document.addEventListener('DOMContentLoaded', () => {
    if(window.innerWidth <= 749) brandsPagination();
});

window.addEventListener('resize', () => {
    if(window.innerWidth <= 749) {
        brandsPagination();
    } else {
        const allLinks = document.querySelectorAll('.js-brands-container #myList .navList-item');
        allLinks?.forEach(item => item.setAttribute('data-toggle', 'on'));
    }
});